module.exports = __webpack_public_path__ + "media/mypage/images/fblogo-9d429bdd7d5f43778f426b8878a74624.png";